import {
  currentOrderArbitrageAtom,
  currentOrderAtom,
  isLoadingArbitrageAtom,
} from "@/core/reatom/state/orders/orders";
import { useAction, useAtom } from "@reatom/npm-react";
import dayjs from "dayjs";
import s from "./style.module.scss";
import Alert from "@/assets/alert.svg?react";
import { toggleModal } from "@/core/reatom/state/modal/modal";
import clsx from "clsx";

export const OrderInfo = () => {
  const [currentOrder] = useAtom(currentOrderAtom);
  const [isLoadingArbitrage] = useAtom(isLoadingArbitrageAtom);
  const handleToggleModal = useAction(toggleModal);
  const [currentOrderArbitrage] = useAtom(currentOrderArbitrageAtom);
  if (isLoadingArbitrage) return null;
  return (
    <>
      {!currentOrder?.is_arbitrage &&
        currentOrder?.process_status === "new" && (
          <>
            <p className={s.titleEpic}>
              {currentOrder?.reserve.status === "reserved"
                ? "Подтверждение исполнителя"
                : "Ожидание оплаты"}
            </p>
            <p className={s.subtitleEpic}>
              {currentOrder?.reserve.status === "reserved"
                ? "Пожалуйста, передайте через чат материалы, необходимые для начала работы."
                : `Оплатите заказ до ${dayjs(
                    currentOrder?.reserve.created_at + 24 * 60 * 60 * 1000
                  ).format("DD.MM.YYYY HH:mm")} `}
            </p>
            <div className={s.chatAlertWrapper}>
              <Alert />
              <p className={s.chatAlert}>
                {currentOrder?.reserve.status === "reserved"
                  ? `Если фрилансер не подтвердит заказ до   ${dayjs(
                      currentOrder?.created_at + 24 * 60 * 60 * 1000
                    ).format("DD.MM.YYYY")} 
                  ${dayjs(
                    currentOrder?.created_at + 24 * 60 * 60 * 1000
                  ).format("HH:mm")} — заказ будет отменен.`
                  : `Чат с фрилансером откроется, когда поступит оплата`}
              </p>
            </div>
          </>
        )}
      {currentOrderArbitrage?.status === "closed" && (
        <>
          <p className={s.titleEpic}>Заказ закрыт</p>
        </>
      )}
      {!currentOrder?.is_arbitrage &&
        currentOrderArbitrage?.status !== "closed" &&
        currentOrder?.process_status === "completed" && (
          <>
            <p className={s.titleEpic}>Работа принята</p>
            <p className={s.subtitleEpic}>
              Вы приняли работу. Исполнителю будет перечислена зарезервированная
              сумма оплаты.
            </p>
          </>
        )}
      {!currentOrder?.is_arbitrage &&
        currentOrder?.process_status === "cancelled" && (
          <>
            <p className={s.titleEpic}>Заказ услуги отменен</p>
            <p className={s.subtitleEpic}>
              Вы отменили заказ услуги{" "}
              {dayjs(currentOrder?.canceled_at).format("DD.MM")} в
              {dayjs(currentOrder?.canceled_at).format("HH:mm")}
            </p>
            <div className={s.chatAlertWrapper}>
              <Alert />
              <p className={s.chatAlert}>
                {currentOrder.cancel_reason === "by_employer"
                  ? currentOrder.reserve.pre_reserve_payed
                    ? "Деньги за услугу вернутся на карту. Сроки зачисления зависят от скорости обработки транзакций по отмененным покупкам в вашем банке."
                    : "Вы можете выбрать другую услугу этого исполнителя или найтинового."
                  : "Деньги за услугу вернутся на карту. Сроки зачисления зависят от скорости обработки транзакций по отмененным покупкам в вашем банке."}
              </p>
            </div>
          </>
        )}
      {!currentOrder?.is_arbitrage &&
        currentOrder?.process_status === "declined" && (
          <>
            <p className={s.titleEpic}>Заказ услуги отменен</p>
            <p className={s.subtitleEpic}>Исполнитель отказался от заказа.</p>
            {currentOrder.status_info && (
              <div className={s.chatAlertWrapper}>
                <Alert />
                <p className={s.chatAlert}>{currentOrder.status_info}</p>
              </div>
            )}
          </>
        )}
      {!currentOrder?.is_arbitrage &&
        currentOrder?.process_status === "accepted" && (
          <>
            <p className={s.titleEpic}>Заказ в процессе выполнения</p>
            <p className={s.subtitleEpic}>
              Исполнитель работает над заказом. Завершите сотрудничество, когда
              проверите результат и получите все материалы.
            </p>
            <div className={s.chatAlertWrapper}>
              <div className={s.alert}>
                <Alert />
              </div>
              <p className={s.chatAlert}>
                <span
                  className={s.link}
                  onClick={() => handleToggleModal("arbitrage")}
                >
                  Обратитесь в арбитраж
                </span>
                , если возникнет спорная ситуация или понадобится техническая
                помощь с завершением заказа.
              </p>
            </div>
          </>
        )}
      {!currentOrder?.is_arbitrage &&
        currentOrder?.process_status === "fix" && (
          <>
            <p className={s.titleEpic}>Заказ в процессе выполнения</p>
            <p className={s.subtitleEpic}>
              Исполнитель работает над заказом. Завершите сотрудничество, когда
              проверите результат и получите все материалы.
            </p>
            <div className={s.chatAlertWrapper}>
              <div className={s.alert}>
                <Alert />
              </div>
              <p className={s.chatAlert}>
                <span
                  className={s.link}
                  onClick={() => handleToggleModal("arbitrage")}
                >
                  Обратитесь в арбитраж
                </span>
                , если возникнет спорная ситуация или понадобится техническая
                помощь с завершением заказа.
              </p>
            </div>
          </>
        )}
      {!currentOrder?.is_arbitrage &&
        currentOrder?.process_status === "work_finished" && (
          <>
            <p className={s.titleEpic}>Работа выполнена</p>
            <p className={s.subtitleEpic}>
              Завершите сотрудничество, когда проверите результат работы и
              получите все материалы.
            </p>
            <div className={s.chatAlertWrapper}>
              <div className={s.alert}>
                <Alert />
              </div>

              <p className={s.chatAlert}>
                <span
                  className={s.link}
                  onClick={() => handleToggleModal("arbitrage")}
                >
                  Обратитесь в арбитраж
                </span>
                , если возникнет спорная ситуация или понадобится техническая
                помощь с завершением заказа.
              </p>
            </div>
          </>
        )}
      {currentOrder?.is_arbitrage &&
        currentOrderArbitrage?.status === "new" && (
          <>
            <p className={s.titleEpic}>Заказ в Арбитраже</p>
            <p className={s.subtitleEpic}>
              Вы обратились в Арбитраж. Команда Арбитража присоединится к вашему
              чату с фрилансером в ближайшее время. Пожалуйста, проверяйте чат и
              отвечайте на вопросы Арбитража не реже раза в сутки.
            </p>
            <div className={clsx(s.chatAlertWrapper, s.arbitrage)}>
              <p className={s.chatAlert}>Причина обращения</p>
              <p className={clsx(s.chatAlert, s.arbitrageReason)}>
                {currentOrderArbitrage
                  ? currentOrderArbitrage.message
                  : "Работа не сдана в срок"}
              </p>
            </div>
          </>
        )}
      {currentOrderArbitrage?.status === "closed" &&
        currentOrder?.is_arbitrage && (
          <>
            <p className={s.titleEpic}>Выплата суммы</p>
            <p className={s.subtitleEpic}>
              Процесс выполнения заказа завершен, спасибо за сотрудничество!
            </p>
            <div className={clsx(s.chatAlertWrapper, s.arbitrage)}>
              <div className={s.innerWrapper}>
                <p className={s.chatAlert}>Решение Арбитража</p>
                <p className={clsx(s.chatAlert, s.arbitrageReason)}>
                  {currentOrderArbitrage?.decision === "payout" &&
                    "Возврат оплаты Заказчику"}
                  {currentOrderArbitrage?.decision === "payback" &&
                    "100% выплата Исполнителю"}
                  {currentOrderArbitrage?.decision === "split" &&
                    "Разделить бюджет"}
                </p>
              </div>
              {currentOrder &&
                currentOrder?.reserve.payback_price.amount > 0 && (
                  <>
                    <hr className={s.hr} />
                    <div className={s.innerWrapper}>
                      <p className={s.chatAlert}>
                        Возврат средств -{" "}
                        <span>
                          {currentOrder?.reserve.payback_price.amount} р
                        </span>
                      </p>
                      <p className={clsx(s.chatAlert, s.arbitrageReason)}>
                        {currentOrder?.reserve.payback_status === "paid" &&
                          "Сумма выплачена"}
                        {currentOrder?.reserve.payback_status ===
                          "in_progress" && "В процессе"}
                        {currentOrder?.reserve.payback_status === "failed" &&
                          "Произошла ошибка"}
                      </p>
                    </div>
                  </>
                )}
            </div>
          </>
        )}
    </>
  );
};
// )}
